module.exports = __webpack_public_path__ + "static/img/44.72c8ece8.svg";